module.exports = __webpack_public_path__ + "static/media/logo_home.c065aa0b.png";